import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from "@components/Reference";
import { Spacer } from "@cleartrip/bento/lib";
import Sandbox from "@components/Sandbox";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "background"
    }}>{`Background`}</h1>
    <p>{`Used to set the properties of a background image`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.bs-auto</Name>
    <Output mdxType="Output">background-size: auto;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bs-cover</Name>
    <Output mdxType="Output">background-size: cover;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bs-contain</Name>
    <Output mdxType="Output">background-size: contain;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.br-repeat</Name>
    <Output mdxType="Output">background-repeat: repeat;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.br-no-repeat</Name>
    <Output mdxType="Output">background-repeat: no-repeat;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.br-repeat-x</Name>
    <Output mdxType="Output">background-repeat: repeat-x;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.br-repeat-y</Name>
    <Output mdxType="Output">background-repeat: repeat-y;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-bottom</Name>
    <Output mdxType="Output">background-position: bottom;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-center</Name>
    <Output mdxType="Output">background-position: center;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-left</Name>
    <Output mdxType="Output">background-position: left;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-left-bottom</Name>
    <Output mdxType="Output">background-position: left-bottom;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-left-top</Name>
    <Output mdxType="Output">background-position: left-top;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-right</Name>
    <Output mdxType="Output">background-position: right;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-right-bottom</Name>
    <Output mdxType="Output">background-position: right-bottom;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-right-top</Name>
    <Output mdxType="Output">background-position: right-top;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.bp-top</Name>
    <Output mdxType="Output">background-position: top;</Output>
  </Property>
    </Reference>
    <h2 {...{
      "id": "background-size"
    }}>{`Background size`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div alt="random image" className="bs-cover br-no-repeat bg-tertiary-100 w-100p" style={{
          height: "200px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/500x180)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="bs-contain br-no-repeat bg-tertiary-100 w-100p" style={{
          height: "200px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/500x180)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="bs-auto br-no-repeat bg-tertiary-100 w-100p" style={{
          height: "200px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/500x180)"
        }} />
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="bs-cover" />
    <div className="bs-contain" />
    <div className="bs-auto" />
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "background-repeat"
    }}>{`Background repeat`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div alt="random image" className="br-repeat bp-center bg-tertiary-100 w-100p" style={{
          height: "200px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-center bg-tertiary-100 w-100p" style={{
          height: "200px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-repeat-x bp-center bg-tertiary-100 w-100p" style={{
          height: "200px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-repeat-y bp-center bg-tertiary-100 w-100p" style={{
          height: "200px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="br-repeat" />
    <div className="br-no-repeat" />
    <div className="br-repeat-x" />
    <div className="br-no-repeat-y" />
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "background-position"
    }}>{`Background position`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div alt="random image" className="br-no-repeat bp-center bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-top bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-right-top bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-right bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-right-bottom bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-bottom bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-left-bottom bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-left bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
    <Spacer my={2} mdxType="Spacer" />
    <div alt="random image" className="br-no-repeat bp-left-top bg-tertiary-100 w-100p" style={{
          height: "140px",
          backgroundImage: "url(https://source.unsplash.com/WLUHO9A_xik/100x100)"
        }} />
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="bp-center" />
    <div className="bp-top" />
    <div className="bp-right-top" />
    <div className="bp-right" />
    <div className="bp-right-bottom" />
    <div className="bp-bottom" />
    <div className="bp-left-bottom" />
    <div className="bp-left" />
    <div className="bp-left-top" />
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      